<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  (valueChange)="onChange($event)"
  [erroremessage]="erroremessage"
  (cancelChange)="cancel()"
  hasfocus="Title"
  [noSubmit]="deactivateSave"
  (submitChange)="save()">
  <ng-container class="footer">
    <div *ngIf="haserror" class="alert alert-danger">
      <div [hidden]="!haserror">
        {{ erroremessage }}
      </div>
    </div>
  </ng-container>
  <ng-container class="content">
    <ng-container *ngIf="formGroup">
      <div class="fcContent">
        <div class="item-detail">
          <ssg-input
            [label]="'ClientApp.FrontOffice.Catalog.Item.Code' | translate"
            name="Code"
            textType="number"
            [max]="99999999"
            [group]="formGroup"
            userClass="select-sm"
            [required]="true"></ssg-input>
          <ssg-select
            *ngIf="!isLight"
            name="GoodsId"
            [label]="'ClientApp.FrontOffice.Catalog.Item.StockItem' | translate"
            [group]="formGroup"
            apiName="Item/ReadProductGoodsLookUp"
            valueFieldName="Id"
            textFieldName="Title"
            userClass="select-md"
            textColumnsName="Title,Code"
            filterKey="Title,Code"
            [columnsTitleName]="'ClientApp.FrontOffice.Catalog.Item.Code' | translate"
            [isMultiColumns]="true"
            (valueChange)="onGoodsIdChanges($event)"
            (valueClear)="onGoodsClear()"
            [hasDefault]="false"
            SortColumn="Code">
          </ssg-select>
          <ssg-input
            [label]="'ClientApp.FrontOffice.Catalog.Item.Caption' | translate"
            textType="text"
            max="50"
            name="Title"
            [group]="formGroup"
            userClass="select-md"
            [required]="true"
            [disabled]="disabledTitle"></ssg-input>
          <div class="d-flex">
            <ssg-select
              name="CategoryId"
              [dataList]="ItemCategoryLookup"
              [label]="'ClientApp.FrontOffice.Catalog.Item.ItemCategory' | translate"
              [group]="formGroup"
              (valueChange)="onChange($event)"
              required="false"
              [disabled]="false"
              userClass="select-sm"
              textFieldName="Title"
              valueFieldName="Id"
              class="categories">
            </ssg-select>
            <ssg-select
              name="MeasurementUnitId"
              [dataList]="MeasurementUnit"
              [label]="'ClientApp.FrontOffice.Catalog.Item.MeasurementUnitId' | translate"
              [group]="formGroup"
              [required]="true"
              required="false"
              [disabled]="false"
              userClass="select-sm"
              textFieldName="Title"
              valueFieldName="Id">
            </ssg-select>
          </div>
          <div class="price-box">
            <ssg-select
              name="SalePriceTypeId"
              [dataList]="SalePriceTypeLookup"
              [label]="'ClientApp.FrontOffice.Catalog.Item.PriceType' | translate"
              [group]="formGroup"
              [required]="true"
              required="false"
              [disabled]="false"
              userClass="select-sm"
              textFieldName="Title"
              valueFieldName="Id"
              class="categories">
            </ssg-select>
            <ssg-input
              name="Price"
              textType="currency"
              isNumberOnly="true"
              [withComma]="true"
              [group]="formGroup"
              required="true"
              userClass="select-sm"
              [required]="true"
              [label]="'ClientApp.FrontOffice.Catalog.Item.DefaultPrice' | translate">
            </ssg-input>
          </div>
          <div
            class="price-box"
            *ngIf="
              currentInformation.AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
              currentInformation.AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb ||
              currentInformation.AccountingKind === SoftWareLicenseKind.AccountingWeb
            ">
            <ssg-select
              name="DetailLedgerId"
              [label]="'ClientApp.FrontOffice.Catalog.Item.DetailedAccount' | translate"
              [group]="formGroup"
              apiName="DetailLedger/GetPagining"
              valueFieldName="Id"
              textFieldName="Title"
              userClass="select-sm"
              textColumnsName="Title,Code"
              filterKey="Title,Code"
              [columnsTitleName]="'ClientApp.FrontOffice.Catalog.Item.DetailCode' | translate"
              [isMultiColumns]="true"
              SortColumn="Code">
            </ssg-select>
          </div>
        </div>

        <div>
          <ssg-select
            [label]="'ClientApp.FrontOffice.Catalog.Item.Type' | translate"
            apiName="Lookup"
            systemName="SALE"
            category="ItemType"
            (CompleteData)="CompleteData($event)"
            textFieldName="Title"
            valueFieldName="Id"
            name="ItemTypeId"
            [group]="formGroup"
            userClass="select-sm"
            [required]="true"></ssg-select>
          <ssg-select
            name="DataDaysWeekTitle"
            class="daysWeek"
            [label]="'ClientApp.FrontOffice.Catalog.Item.DaysOfWeek' | translate"
            [dataList]="DataDaysWeek"
            systemName="SALE"
            category="DaysWeek"
            (CompleteData)="CompleteData($event)"
            textFieldName="Title"
            valueFieldName="Id"
            [group]="formGroup"
            userClass="select-sm"
            [multiple]="true"></ssg-select>
          <div class="taxApply">
            <ssg-radiobox
              name="TaxApplyTypeId"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Catalog.Item.HowToApplyTaxes' | translate"
              id="TaxApplyTypeId"
              apiName="Lookup"
              systemName="SALE"
              category="TaxServiceApplyType"
              textFieldName="Title"
              valueFieldName="Id"
              userClass="select-md"
              (CompleteData)="CompleteData($event)">
            </ssg-radiobox>
          </div>
          <div>
            <ssg-radiobox
              name="ServiceApplyTypeId"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.Catalog.Item.HowToApplyService' | translate"
              id="ServiceApplyTypeId"
              apiName="Lookup"
              systemName="SALE"
              category="TaxServiceApplyType"
              textFieldName="Title"
              valueFieldName="Id"
              userClass="select-md"
              (CompleteData)="CompleteData($event)"></ssg-radiobox>
          </div>

          <div class="mt-3 d-flex">
            <ssg-checkbox
              class="ml-3"
              name="IsOrganizationalDiscount"
              [label]="'ClientApp.FrontOffice.Catalog.Item.IsOrganizationalDiscount' | translate"
              systemName="SALE"
              required="false"
              [group]="formGroup"
              (valueChange)="showOrganizationalDiscount($event)">
            </ssg-checkbox>
            <ssg-input
              *ngIf="model?.IsOrganizationalDiscount"
              name="OrganizationalDiscount"
              textType="currency"
              isNumberOnly="true"
              [withComma]="true"
              [group]="formGroup"
              required="true"
              userClass="select-sm"
              textFieldName="Title"
              valueFieldName="Id"
              [label]="'ClientApp.FrontOffice.Catalog.Item.OrganizationalDiscount' | translate">
            </ssg-input>
          </div>
        </div>
      </div>

      <ssg-tabset (tabChange)="selectTab($event)" class="tabcontainer tabcontentbox">
        <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Catalog.Item.Prices' | translate">
          <editable-grid
            *ngIf="this.activeTabTitle === ('ClientApp.FrontOffice.Catalog.Item.Prices' | translate) && Prices?.length > 0"
            [columns]="Prices"
            [DefaultValues]="DefaultValues"
            [dataList]="model.Prices">
          </editable-grid>
        </ssg-tab>
        <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Catalog.Item.Dependents' | translate">
          <editable-grid
            *ngIf="this.activeTabTitle === ('ClientApp.FrontOffice.Catalog.Item.Dependents' | translate) && Dependents?.length > 0"
            [DefaultValues]="DefaultValues"
            [noReduplicative]="true"
            [isDelete]="true"
            [columns]="Dependents"
            [dataList]="model.Dependents"
            (afterSaved)="addHandler($event)">
          </editable-grid>
        </ssg-tab>
        <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Catalog.Item.Barcodes' | translate">
          <editable-grid
            *ngIf="this.activeTabTitle === ('ClientApp.FrontOffice.Catalog.Item.Barcodes' | translate) && Barcodes?.length > 0"
            [columns]="Barcodes"
            [dataList]="model.Barcodes">
          </editable-grid>
        </ssg-tab>
        <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Catalog.Item.Details' | translate">
          <div class="row">
            <div class="box-group">
              <ssg-input
                name="Title_En"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Catalog.Item.Title_En' | translate"
                required="false"
                disabled="false"
                maxLength="1024"
                class="info"
                max="40">
              </ssg-input>
            </div>
            <div class="box-group">
              <ssg-input
                id="chbIngredients"
                name="Ingredients"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Catalog.Item.Ingredients' | translate"
                required="false"
                disabled="false"
                maxLength="1024"
                class="info"
                max="255">
              </ssg-input>
            </div>
            <div class="box-group">
              <ssg-input
                name="Ingredients_En"
                [label]="'ClientApp.FrontOffice.Catalog.Item.Ingredients_En' | translate"
                [group]="formGroup"
                required="false"
                textType="text"
                maxLength="1024"
                [disabled]="false"
                class="info"
                max="255">
              </ssg-input>
            </div>

            <div class="box-group">
              <ssg-input
                name="Description"
                [label]="'ClientApp.FrontOffice.Catalog.Item.Description' | translate"
                [group]="formGroup"
                required="false"
                textType="text"
                [disabled]="false"
                maxLength="1024"
                class="info">
              </ssg-input>
            </div>
            <div class="box-group">
              <ssg-input
                name="Description_En"
                [label]="'ClientApp.FrontOffice.Catalog.Item.Description_En' | translate"
                [group]="formGroup"
                required="false"
                textType="text"
                [disabled]="false"
                maxLength="1024"
                class="info">
              </ssg-input>
            </div>
            <div class="infocalery">
              <ssg-input
                name="Calories"
                [label]="'ClientApp.FrontOffice.Catalog.Item.Calories' | translate"
                [group]="formGroup"
                required="false"
                textType="number"
                [max]="999999999999"
                [disabled]="false">
              </ssg-input>
            </div>
            <div class="infocalery">
              <ssg-input
                id="chbCookingTime"
                name="CookingTime"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Catalog.Item.CookingTime' | translate"
                required="false"
                textType="number"
                [max]="999999999999"
                disabled="false"
                class="info"
                isNumberOnly="true">
              </ssg-input>
            </div>

            <div class="infocalery">
              <ssg-input
                name="Tax"
                [label]="'ClientApp.FrontOffice.Catalog.Item.Tax' | translate"
                [group]="formGroup"
                required="false"
                textType="currency"
                [disabled]="false"
                textType="number"
                [max]="999"
                class="info"
                isNumberOnly="true">
              </ssg-input>
            </div>
            <div class="infocalery">
              <ssg-input
                name="Toll"
                [label]="'ClientApp.FrontOffice.Catalog.Item.Toll' | translate"
                [group]="formGroup"
                required="false"
                textType="currency"
                [disabled]="false"
                maxLength="1024"
                textType="number"
                [max]="999"
                class="info"
                isNumberOnly="true">
              </ssg-input>
            </div>
            <div class="infocalery">
              <ssg-input
                name="ItemSerial"
                [label]="'ClientApp.FrontOffice.Catalog.Item.SerialItem' | translate"
                [group]="formGroup"
                required="false"
                textType="number"
                [disabled]="false"
                maxLength="1024"
                class="info">
              </ssg-input>
            </div>
            <div class="infocalery">
              <ssg-input
                name="PackingPrice"
                [label]="'ClientApp.FrontOffice.Catalog.Item.PackingPrice' | translate"
                [group]="formGroup"
                required="false"
                textType="currency"
                [max]="999999999999"
                [disabled]="false"
                maxLength="1024"
                class="info"
                isNumberOnly="true">
              </ssg-input>
            </div>
            <div class="infocalery">
              <ssg-checkbox
                id="UsedInInvDailyVoucher"
                name="UsedInInvDailyVoucher"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.Catalog.Item.UsedInInvDailyVoucher' | translate"
                disabled="false">
              </ssg-checkbox>
            </div>
          </div>
        </ssg-tab>
        <ssg-tab *ngIf="isAccessToAllBranches" [tabTitle]="'ClientApp.FrontOffice.Catalog.Item.Branch' | translate">
          <editable-grid
            *ngIf="
              this.activeTabTitle === ('ClientApp.FrontOffice.Catalog.Item.Branch' | translate) &&
              Branches.length > 0 &&
              model?.Branches?.length > 0 &&
              showBranch
            "
            [DefaultValues]="DefaultValues"
            [columns]="Branches"
            [dataList]="model.Branches"
            [isAdd]="false"
            [isDelete]="false">
          </editable-grid>
        </ssg-tab>
      </ssg-tabset>
    </ng-container>
  </ng-container>
</dynamic-form>
